export default (state = [], action) => {
    
    switch (action.type){
        case 'SOLUTION_BISECCION':
            return action.payload;
        default:
            return [];
    }
};